import { frontApiUrl } from '../../../../core/Api/Front/url';
import { Locale } from '../../../../core/i18n/Locale';
import { PointsOfInterestResponseSuccess } from '../../../../pages/api/front/points-of-interest';
import { generateUrl } from '../../../../shared/utilities/routing/routing';
import { handleResponse } from '../../../shared/types/handlers';

export async function getPointsOfInterestFromFront({
    locale,
    destinationId,
    isOnline,
    regionId,
    excludeId,
    page,
    perPage,
}: {
    locale: Locale;
    destinationId?: number;
    isOnline?: true;
    regionId?: number;
    excludeId?: number;
    page: number;
    perPage: number;
}) {
    const response = await fetch(
        frontApiUrl(
            generateUrl('api_points_of_interest', locale, {
                locale,
                destinationId,
                isOnline: isOnline?.toString(),
                regionId,
                excludeId,
                page,
                perPage,
            }),
        ),
    );

    return await handleResponse<PointsOfInterestResponseSuccess>(response);
}
